module.exports = __webpack_public_path__ + "static/media/chevron-right.ae1b8cb4.svg";